import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { BehaviorSubject, Observable } from 'rxjs/Rx';

import { AppConfig } from '../app.config';

export function localisationFactory(localisation: LocalisationService) {
  return () => localisation.init(AppConfig.defaultLocale);
}

@Injectable()
export class LocalisationService {
  private locale: string = null;
  private defaults: any = null;
  private values: any = null;

  private centreComponentData = new BehaviorSubject<boolean>(false);
  public centreComponent;

  constructor(private http: HttpClient) {
    this.centreComponent = this.centreComponentData.asObservable();
  }

  init(defaultLocale: string): Promise<any> {
    let userLocale = sessionStorage.getItem('locale');
    this.locale = !userLocale ? defaultLocale : userLocale;

    return Promise.all([
      this.readLocaleFile(defaultLocale),
      !userLocale ? Promise.resolve() : this.readLocaleFile(this.locale)
    ]).then(values => {
      this.defaults = values[0];
      this.values = _.merge(_.cloneDeep(this.defaults), values[1]);
    });
  }

  updateCentreComponent(val: boolean) {
    this.centreComponentData.next(val);
  }

  updateCurrentLanguage(locale: string): Promise<void> {
    this.locale = locale;
    sessionStorage.setItem('locale', this.locale);
    return this.readLocaleFile(locale).then(values => {
      this.values = _.merge(_.cloneDeep(this.defaults), values);
      return this.values;
    });
  }

  getTranslationsForComponent<TLocale>(key: string): TLocale {
    if (!this.values && !this.defaults) {
      throw new Error(`Translations for locale '${this.locale}' could not be found`);
    }

    let t;

    if (this.values) t = this.values[key] || this.defaults[key];
    else t = this.defaults[key];

    return t as TLocale;
  }

  private readLocaleFile(locale: string): Promise<any> {
    let filePath = 'locale/messages.' + locale + '.json';

    return this.http
      .get(filePath)
      .toPromise()
      .catch(err => Observable.throw(err));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/localisation.service.ts